export * from './umpire-component-footer';
